import React from 'react';

const ElipsProgressbarFillIcon = ({
    width = 125,
    height = 69,
    stroke = 'none',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 125 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.61631 69C2.51451 69 -0.0241609 66.4811 0.23237 63.3899C1.27638 50.8097 5.81641 38.7122 13.4078 28.4428C22.122 16.6543 34.4097 7.87989 48.5097 3.3771C62.6097 -1.1257 77.7981 -1.1257 91.8981 3.37711C104.174 7.29751 115.077 14.456 123.443 24.0226C125.496 26.3705 124.92 29.9282 122.382 31.7408C119.902 33.5117 116.479 32.9454 114.445 30.6767C107.482 22.9124 98.5058 17.0954 88.427 13.8768C76.583 10.0944 63.8247 10.0944 51.9808 13.8768C40.1368 17.6591 29.8151 25.0296 22.4951 34.932C16.2986 43.3145 12.5224 53.147 11.5092 63.3926C11.2039 66.4794 8.71811 69 5.61631 69Z"
                fill="url(#paint0_linear_913_10219)"
                stroke={stroke}
            />
            <defs>
                <linearGradient
                    id="paint0_linear_913_10219"
                    x1="-1.36276e-06"
                    y1="64.3134"
                    x2="127.215"
                    y2="5.14867"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="var(--primary-500)" />
                    <stop offset="1" stop-color="var(--primary-300)" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ElipsProgressbarFillIcon;
